/**
 * Data access for the models module.
 *
 * Types come from the Worker's contract file (`src/worker/api/models.contract.ts`),
 * so the API and the screens are typed from a single source.
 */

import { apiFetch } from '@app/lib/api'
import type {
  ModelSearchMode,
  ModelDetail,
  ModelListResponse,
  ModelSortOrder,
} from '../../../worker/api/models.contract'

export type {
  BomLine,
  BomProcess,
  ColorMapping,
  EmirStatus,
  ModelColor,
  ModelDetail,
  ModelEmir,
  ModelListItem,
  ModelListResponse,
  ModelSearchMode,
  ModelSize,
  ModelSizeDistribution,
  ModelSortOrder,
  SizeMapping,
} from '../../../worker/api/models.contract'

export interface ModelListParams {
  query: string
  mode: ModelSearchMode
  sort: ModelSortOrder
  page: number
  pageSize?: number
}

export const modelsKeys = {
  all: ['models'] as const,
  list: (params: ModelListParams) => ['models', 'list', params] as const,
  detail: (modelKod: string) => ['models', 'detail', modelKod] as const,
}

export function fetchModelList(params: ModelListParams): Promise<ModelListResponse> {
  const search = new URLSearchParams({
    mode: params.mode,
    sort: params.sort,
    page: String(params.page),
  })
  if (params.query) search.set('query', params.query)
  if (params.pageSize) search.set('pageSize', String(params.pageSize))
  return apiFetch<ModelListResponse>(`/models?${search.toString()}`)
}

export function fetchModelDetail(modelKod: string): Promise<ModelDetail> {
  return apiFetch<ModelDetail>(`/models/${encodeURIComponent(modelKod)}`)
}
